var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"border-b border-gray-200 py-3 sm:py-5 px-4 sm:px-6 text-base sm:text-xl m-0 bg-transparent text-black"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }